import { BROWSER_TYPE, DEVICE_TYPE } from 'Enum/Feedback';
export interface IDeviceInfo {
  deviceId: DEVICE_TYPE;
  browserId: BROWSER_TYPE;
  deviceDetails: string;
}

export const detectDeviceInfo: () => IDeviceInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  let deviceId: DEVICE_TYPE = DEVICE_TYPE.OTHER;
  let browserId: BROWSER_TYPE = BROWSER_TYPE.OTHER;
  let deviceDetails = navigator.userAgent;

  // Detect device
  if (/iphone|ipad|ipod/.test(userAgent)) {
    deviceId = DEVICE_TYPE.IOS;
  } else if (/android/.test(userAgent)) {
    deviceId = DEVICE_TYPE.ANDROID;
  } else if (/windows|macintosh|linux/.test(userAgent)) {
    deviceId = DEVICE_TYPE.PC;
  }

  // Detect browser
  if (/chrome/.test(userAgent) && !/edge|edg|opr/.test(userAgent)) {
    browserId = BROWSER_TYPE.CHROME;
  } else if (/safari/.test(userAgent) && !/chrome/.test(userAgent)) {
    browserId = BROWSER_TYPE.SAFARI;
  } else if (/firefox/.test(userAgent)) {
    browserId = BROWSER_TYPE.FIREFOX;
  } else if (/edg/.test(userAgent)) {
    browserId = BROWSER_TYPE.EDGE;
  } else if (/samsungbrowser/.test(userAgent)) {
    browserId = BROWSER_TYPE.SAMSUNG_INTERNET;
  } else if (/opr|opera/.test(userAgent)) {
    browserId = BROWSER_TYPE.OPERA;
  }

  return { deviceId, browserId, deviceDetails };
};
